export default __webpack_public_path__ + "static/Houston-af5d669b43070e1ccafc952fd2f20287.webp";